module.exports = __webpack_public_path__ + "static/img/nodata-member.4673f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/nodata-member.png
// module id = X1BI
// module chunks = 4